"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var elementTypes;
(function (elementTypes) {
    /** a collection of multiple elements */
    elementTypes["group"] = "group";
    /** indicates a new page on a form */
    elementTypes["page"] = "page";
    elementTypes["heading"] = "heading";
    elementTypes["help"] = "help";
    elementTypes["text"] = "text";
    elementTypes["textArea"] = "textArea";
    elementTypes["duration"] = "duration";
    elementTypes["email"] = "email";
    elementTypes["number"] = "number";
    elementTypes["date"] = "date";
    elementTypes["phone"] = "tel";
    elementTypes["checkbox"] = "checkbox";
    /** a drop-down list */
    elementTypes["select"] = "select";
    /** a likert scale display */
    elementTypes["likert"] = "likert";
    /** a radio button display. also covers the milestone comparison type */
    elementTypes["radio"] = "radio";
    /** a country's way to number you. SSN, for example. */
    elementTypes["nationalId"] = "nationalId";
    elementTypes["time"] = "time";
    elementTypes["attachment"] = "attachment";
    elementTypes["electronicSignature"] = "electronicSignature";
    elementTypes["gisCoordinates"] = "gisCoordinates";
    elementTypes["postalCode"] = "postalCode";
    /** a text element that can specify valid sets of characters  */
    elementTypes["specialText"] = "specialText";
    /** displays label text as markdown */
    elementTypes["html"] = "html-label";
    /** displays information about an email that was sent */
    elementTypes["emailNotification"] = "emailNotification";
    elementTypes["ignore"] = "ignore";
    elementTypes["unsupported"] = "unsupported";
    elementTypes["undefined"] = "unknown";
})(elementTypes = exports.elementTypes || (exports.elementTypes = {}));
/** ISO 3166 alpha-3 (3 char) country codes, used especially by postal organizations */
var countryCodes;
(function (countryCodes) {
    countryCodes["UnitedKingdom"] = "GBR";
    countryCodes["Canada"] = "CAN";
    countryCodes["UnitedStates"] = "USA";
})(countryCodes = exports.countryCodes || (exports.countryCodes = {}));
/** used for date validation */
var CountryEnum;
(function (CountryEnum) {
    CountryEnum["Canada"] = "CA";
    CountryEnum["UnitedKingdom"] = "UK";
    CountryEnum["UnitedStates"] = "US";
})(CountryEnum = exports.CountryEnum || (exports.CountryEnum = {}));
var numericElementTypes;
(function (numericElementTypes) {
    numericElementTypes["RAW_NUMBER"] = "raw";
    numericElementTypes["PERCENTAGE"] = "percentage";
    numericElementTypes["MONEY"] = "money";
    numericElementTypes["UNDEFINED"] = "undefined";
})(numericElementTypes = exports.numericElementTypes || (exports.numericElementTypes = {}));
var nationalIdTypes;
(function (nationalIdTypes) {
    nationalIdTypes["SSN"] = "ssn";
    nationalIdTypes["SIN"] = "sin";
})(nationalIdTypes = exports.nationalIdTypes || (exports.nationalIdTypes = {}));
var timePeriod;
(function (timePeriod) {
    timePeriod["AM"] = "AM";
    timePeriod["PM"] = "PM";
})(timePeriod = exports.timePeriod || (exports.timePeriod = {}));
/** This defines different default styles that the GroupElement can have. TODO: expand in PP-1431 */
var groupTypes;
(function (groupTypes) {
    /** This will have a default style that indents the subElements and changes their label to a field label */
    groupTypes["INDENTED"] = "indented";
    /** This will have a default style that places the subElements on a single row and changes their label to a field label */
    groupTypes["INLINE"] = "inline";
    /** This will add no default style, this forces the user to manually set the styles for this element */
    groupTypes["CUSTOM"] = "custom";
})(groupTypes = exports.groupTypes || (exports.groupTypes = {}));
/** Determines how the signature element behaves and saves data. */
var electronicSignatureModes;
(function (electronicSignatureModes) {
    /** Data output is in ETO's proprietary coordinate format */
    electronicSignatureModes["ETO"] = "eto";
    /** Data output is an image URL */
    electronicSignatureModes["APRICOT"] = "apricot";
})(electronicSignatureModes = exports.electronicSignatureModes || (exports.electronicSignatureModes = {}));
/** This defines allowed types of text that can be entered on a SpecialTextElement */
var specialTextTypes;
(function (specialTextTypes) {
    /** This will allow any kind of text to be entered */
    specialTextTypes["ANY"] = "any";
    /** this will allow only numbers to be entered */
    specialTextTypes["NUMERIC"] = "numeric";
    /** this will allow only letters to be entered */
    specialTextTypes["ALPHA"] = "alpha";
    /** this will allow only letters and numbers to be entered */
    specialTextTypes["ALPHA_NUMERIC"] = "alphaNumeric";
})(specialTextTypes = exports.specialTextTypes || (exports.specialTextTypes = {}));
/** These are different ways that subElements of a group element  */
var requireType;
(function (requireType) {
    /** all subElements will be required */
    requireType["ALL"] = "require.all";
    /** only some of the subElements will be required */
    requireType["SOME"] = "require.some";
    /** completing any of the subElements will satisfy the required definition */
    requireType["ANY"] = "require.any";
})(requireType = exports.requireType || (exports.requireType = {}));
/** These are different ways that subElements of a group element  */
var dataFormatType;
(function (dataFormatType) {
    /** the group element does not have a representation of the combined element value */
    dataFormatType["NONE"] = "data-format.none";
    /** group has a multiple choice element and a text other option that combine to be the complete value*/
    dataFormatType["MULTIPLE_CHOICE_OTHER"] = "data-format.mc-other";
    /** group has a zip code and an extension, that combine into a single string value */
    dataFormatType["ZIP_EXTENSION"] = "data-format.zip-extension";
})(dataFormatType = exports.dataFormatType || (exports.dataFormatType = {}));
//# sourceMappingURL=form-constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-constants.js
// module id = 1107
// module chunks = 0